<template>
  <div class="main">
    <app-header v-bind="headerConfig"></app-header>
    <div class="page-loadmore-wrapper">
      <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded"
                   ref="loadmore">
        <ul class="my-game">
          <template>
            <li v-if="stories.length > 0" v-for="item in stories" class="g-list clearfix" :key="item.guid"
                @click="openOldStory(item.guid)">
              <div class="cover">
                <img v-if="getPicSrc(item) != ''" :src="getPicSrc(item)" :alt="item.proj_name">
                <img src="../../static/image/def_cover.png?v=3" v-else>
              </div>
              <div class="detail">
                <template>
                  <p class="g-name" v-text="item.proj_name"></p>
                  <p>{{configText.status}}：{{comMethods.getStoryAuditStatus(item)}}</p>
                  <p>{{configText.runs}}：{{item.play_times == ""?"无":item.play_times}}</p>
                  <p>{{configText.wordCount}}：{{item.release_word_sum ==""?0:item.release_word_sum}}</p>
                  <p>{{configText.createTime}}：{{item.time.substr(0,item.time.length-9)}}</p>
                </template>
              </div>
            </li>
            <li v-else>
              <div>没有数据</div>
            </li>
          </template>
          <template v-if="isLoading">
            <div class="loading">
              <mt-spinner type="double-bounce" color="#ff6600"></mt-spinner>
            </div>
          </template>
        </ul>
      </mt-loadmore>
    </div>
    <create-story-btn v-if="moduleState.storysList"></create-story-btn>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import store from '../store/store';
  import {ProjectData} from '../store/ProjectData';
  import configText from '../config/ConfigText';
  import {ComponentName, Methods} from '../const/common';
  import {Toast} from 'mint-ui';
  import AppHeader from '../components/header';
  import CreateStory from '../components/create_story_btn';

  export default {
    name: 'my-game',
    store,
    components: {
      'app-header': AppHeader,
      'create-story-btn': CreateStory
    },
    data() {
      return {
        headerConfig: {
          title: configText.gamesListHeader,
          isStoryMenu: false,
          backNote: ''
        },
        projectData: new ProjectData(this),
        configText: configText,
        allLoaded: false,
        bottomStatus: '',
        stories: [],
        isLoading: false,
        comMethods: Methods
      }
    },
    computed: {
      ...mapState(['myStorysLength', 'moduleState'])
    },
    methods: {
      initData() {
        this.isLoading = true;
        this.projectData.getStoryList(this.getListComplete, this.getListError, this);
      },
      //测试环境的封面图
      getPicSrc(item) {
        item.real_thumb = item.real_thumb.replace("http:","");
        item.real_thumb = item.real_thumb.replace("https:","");
        return window.location.href.indexOf('test-') > -1 || window.location.href.indexOf('tool.') > -1 ? item.real_thumb.replace('orange', 'demo') : item.real_thumb
      },
      getListComplete(res) {
        this.isLoading = false;

        if (res.code === 0 && res.ret === 1) {
          this.stories = res.data;
          store.state.myStorysLength = res.data.length;
        } else {
          this.stories = [];
        }
      },
      getListError() {
        this.isLoading = false;
        this.stories = [];
      },
      setStoryDetail() {
        if (Middle.ProjectData === null) {
          alert('打开失败，工程数据为空');
        } else {
          let openComponent = null;

          store.commit('editStorySetout');
          if (Methods.getChapterVal('length') > 0 && Methods.getStoryStatus() !== 1) {
            Methods.setHeaderConf('editStory', '返回', ComponentName.STORYS_LIST);
            Methods.storyLoading(true);
            openComponent = ComponentName.EDIT_STORY;
          } else {
            store.state.parrent.createPattern = Methods.getStoryMode();
            Methods.setHeaderConf('editStoryRole', '作品管理', ComponentName.STORYS_LIST);
            openComponent = ComponentName.EDIT_STORY_ROLE;
          }
          Methods.cutComponent([openComponent], true);
          Methods.cutComponent([ComponentName.STORYS_LIST], false);
        }
      },
      openOldStory(guid) {
        Middle.ServerPort.GetInstance().getProjectFile(guid, this.setStoryDetail, this, null, null);
        Methods.checkChapterHash(2);
      },
      handleBottomChange(status) {
        this.bottomStatus = status;
      },
      loadBottom() {}
    },
    mounted() {
      let _store = store.state;

      this.initData();
      _store.viewHeight = document.documentElement.clientHeight;
    }
  }
</script>

<style scoped>
  @import "../style/css/my_games.css";
</style>



// WEBPACK FOOTER //
// src/components/my_games.vue